import Vue from "vue";
import instance from './axios'
import { Toast } from 'vant'
Vue.use(Toast)
let toast = null
const fetchData = async(url, method, data = null, loading = true) => {
    let httpOpts = {
        url,
        method
    };
    if (typeof data === 'boolean') {
        loading = data;
        data = null
    }
    loading && (toast = Toast.loading({
        duration: 0,
        message: 'loading...',
        forbidClick: true
    }));
    httpOpts = method === 'get' ? {
        ...httpOpts,
        params: data,
    } : {
        ...httpOpts,
        data,
    };
    return new Promise((resolve, reject) => {
        instance(httpOpts)
            .then(res => {
                res && resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
            .finally(() => {
                if (loading) {
                    setTimeout(() => {
                        toast.clear()
                    }, 500);
                }
            })
    })
}
export const getRequest = (url, data, load) => fetchData(url, 'get', data, load) // get请求
export const postRequest = (url, data, load) => fetchData(url, 'post', data, load) // post请求
export const deleteRequest = (url, data, load) => fetchData(url, 'delete', data, load) // delete请求
export const putRequest = (url, data, load) => fetchData(url, 'put', data, load) // put请求